// custom routings taken from https://api.staylive.tv/platform/67/home
const mappings = {
  2677: '/fotboll/damallsvenskan/livestream/{id}',
  2603: '/bandy/elitserien/livestream/{id}',
  3210: '/bandy/elitserien/livestream/{id}',
  3333: '/fotboll/svenskacupen/livestream/{id}',
};

const baseUrl = 'https://www.sportbladetplay.se';

/**
 * @param {StayliveStream} stream
 * @return {string}
 */
function getLivestreamUrl(stream) {
  const { id, seo_string, channelid } = stream;

  if (mappings[channelid]) {
    const path = mappings[channelid].replace('{id}', seo_string);

    return `${baseUrl}${path}`;
  }

  return `${baseUrl}/video?id=${id}`;
}

export default getLivestreamUrl;
